import {
  createFiltersAndTermSearchParams,
  Filters
} from "features/resource-discover/utils";

export const linkToCurrentPageWithQueryParams = ({
  filters,
  text
}: {
  filters: Filters;
  text?: string;
}): string => {
  return `.?${createFiltersAndTermSearchParams(filters, text)}`;
};

export const linkToResourceDiscoverFeedback = () => {
  return "https://forms.gle/2E5uTCun354mwLQi9";
};

export function linkToTutorLandingPage_deprecated() {
  return `/tutor`;
}
